import clsx from 'clsx'
import { SEGMENTS, SegmentId } from '../../constants/socials'

type Props = {
  value: SegmentId[]
  onChange: (next: SegmentId[]) => void
}

export function SegmentSelector({ value, onChange }: Props) {
  const toggle = (id: SegmentId) => {
    onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id])
  }
  return (
    <div className="flex flex-wrap gap-2">
      {SEGMENTS.map((segment) => {
        const selected = value.includes(segment.id)
        return (
          <button
            key={segment.id}
            type="button"
            onClick={() => toggle(segment.id)}
            aria-pressed={selected}
            className={clsx(
              'rounded-full px-3.5 py-2 text-sm transition-colors',
              selected
                ? 'bg-primary-500 text-black'
                : 'bg-white/[0.04] text-theme-text-subtle ring-1 ring-white/10',
            )}
          >
            {segment.label}
          </button>
        )
      })}
    </div>
  )
}
